import { defineMessages } from 'react-intl';

/** The words of the Catalog links form (design c1, c1b, c2, c7). */
export const catalogLinksMessages = defineMessages({
  song: { id: 'app.sml.smartlinks.editor.catalog.song', defaultMessage: 'Song' },
  songOut: { id: 'app.sml.smartlinks.editor.catalog.song_out', defaultMessage: '{artist} · out {date}' },
  songNoDate: { id: 'app.sml.smartlinks.editor.catalog.song_no_date', defaultMessage: '{artist} · no release day yet' },
  upcoming: { id: 'app.sml.smartlinks.editor.catalog.upcoming', defaultMessage: 'Upcoming' },
  out: { id: 'app.sml.smartlinks.editor.catalog.out', defaultMessage: 'Out' },
  change: { id: 'app.sml.smartlinks.editor.catalog.change', defaultMessage: 'Change' },
  now: { id: 'app.sml.smartlinks.editor.catalog.timeline.now', defaultMessage: 'Now' },
  nowPresave: { id: 'app.sml.smartlinks.editor.catalog.timeline.now_presave', defaultMessage: 'Pre-save buttons' },
  nowCountdown: { id: 'app.sml.smartlinks.editor.catalog.timeline.now_countdown', defaultMessage: 'Countdown' },
  dayPlay: { id: 'app.sml.smartlinks.editor.catalog.timeline.day_play', defaultMessage: 'Play buttons' },
  presave: { id: 'app.sml.smartlinks.editor.catalog.presave', defaultMessage: 'Let fans pre-save' },
  presaveHelp: {
    id: 'app.sml.smartlinks.editor.catalog.presave_help',
    defaultMessage: "Every pre-save lands in the fan's library on release day.",
  },
  presaveLockedHelp: {
    id: 'app.sml.smartlinks.editor.catalog.presave_locked_help',
    defaultMessage:
      'Fans who pre-save hear {title} on day one. On Free the page shows the countdown until release day, then the play buttons.',
  },
  presaveNeedsDate: {
    id: 'app.sml.smartlinks.editor.catalog.presave_needs_date',
    defaultMessage: 'Give the song a release day to take pre-saves.',
  },
  unlock: { id: 'app.sml.smartlinks.editor.catalog.unlock', defaultMessage: 'Unlock pre-saves' },
  services: { id: 'app.sml.smartlinks.editor.catalog.services', defaultMessage: 'Services, in page order' },
  servicesCount: {
    id: 'app.sml.smartlinks.editor.catalog.services_count',
    defaultMessage: '{on} of {all} on',
  },
  servicesFound: {
    id: 'app.sml.smartlinks.editor.catalog.services_found',
    defaultMessage: '{found} found · {missing} not yet',
  },
  presaveLabel: { id: 'app.sml.smartlinks.editor.catalog.presave_label', defaultMessage: 'Pre-save' },
  preAddLabel: { id: 'app.sml.smartlinks.editor.catalog.pre_add_label', defaultMessage: 'Pre-add' },
  playOnly: { id: 'app.sml.smartlinks.editor.catalog.play_only', defaultMessage: 'Shows on release day' },
  found: { id: 'app.sml.smartlinks.editor.catalog.found', defaultMessage: 'Found' },
  notFound: { id: 'app.sml.smartlinks.editor.catalog.not_found', defaultMessage: 'Not found yet' },
  servicesHelp: {
    id: 'app.sml.smartlinks.editor.catalog.services_help',
    defaultMessage: 'Off = the service never shows a pre-save button on this page.',
  },
  servicesFoundHelp: {
    id: 'app.sml.smartlinks.editor.catalog.services_found_help',
    defaultMessage: 'A service with no link stays off the page. It shows by itself when we find the song.',
  },
  serviceSwitch: { id: 'app.sml.smartlinks.editor.catalog.service_switch', defaultMessage: 'Pre-save on {name}' },
  autoNoteBefore: {
    id: 'app.sml.smartlinks.editor.catalog.auto_note_before',
    defaultMessage:
      'Links update by themselves. On release day MUSIC24 finds {title} on each service and swaps the pre-save buttons for play buttons. You do not publish again.',
  },
  autoNoteAfter: {
    id: 'app.sml.smartlinks.editor.catalog.auto_note_after',
    defaultMessage:
      'Links update by themselves. When MUSIC24 finds {title} on a new service, the link shows here and on the page.',
  },
  noLinks: {
    id: 'app.sml.smartlinks.editor.catalog.no_links',
    defaultMessage:
      'We look for {title} on every service. Most services show a new song within a day. The links show here and on the page when we find them.',
  },
  addLinkOnSongPage: {
    id: 'app.sml.smartlinks.editor.catalog.add_link_song_page',
    defaultMessage: 'Have a link already? Add it on the song page',
  },
  fans: {
    id: 'app.sml.smartlinks.editor.catalog.fans',
    defaultMessage:
      '{count, plural, one {# fan} other {# fans}} pre-saved {title}. All of them have it in their library now.',
  },
  closed: {
    id: 'app.sml.smartlinks.editor.catalog.closed',
    defaultMessage: 'The pre-save of {title} ended. The page hides this block.',
  },
  songGone: {
    id: 'app.sml.smartlinks.editor.catalog.song_gone',
    defaultMessage:
      'Hidden on the page: the song left the Catalog. Delete the block, or add Catalog links of another song.',
  },
  presaveFailed: {
    id: 'app.sml.smartlinks.editor.catalog.presave_failed',
    defaultMessage: 'We could not change the pre-save. Try again.',
  },
});
